var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import { makeStyles } from "../../styles/index";
import { useColor } from "../../hooks/useColor";
import { capitalize } from "../../utils/capitalize";
// TODO 固定値は仮
var styles = function (theme) { return ({
    root: {
        margin: 0,
    },
    /* Styles applied to the root element if `variant="heading"`. */
    heading: theme.typography.heading,
    /* Styles applied to the root element if `variant="title"`. */
    title: theme.typography.title,
    /* Styles applied to the root element if `variant="body2"`. */
    body2: theme.typography.body2,
    /* Styles applied to the root element if `variant="body1"`. */
    body1: theme.typography.body1,
    /* Styles applied to the root element if `variant="caption"`. */
    caption: theme.typography.caption,
    /* Styles applied to the root element if `variant="minimum"`. */
    minimum: theme.typography.minimum,
    /* Styles applied to the root element if `variant="inherit"`. */
    inherit: {},
    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
        textAlign: 'left',
    },
    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
        textAlign: 'center',
    },
    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
        textAlign: 'right',
    },
    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
        textAlign: 'justify',
    },
    /* Styles applied to the root element if `bold={true}`. */
    bold: {
        fontWeight: 'bold',
    },
    /* Styles applied to the root element if `nowrap={true}`. */
    noWrap: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    /* Styles applied to the root element if `gutterBottom={true}`. */
    gutterBottom: {
        marginBottom: '0.35em',
    },
    /* Styles applied to the root element if `paragraph={true}`. */
    paragraph: {
        marginBottom: theme.spacing(2),
    },
    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
        color: 'inherit',
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
        color: theme.palette.primary.main,
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
        color: theme.palette.secondary.main,
    },
    /* Styles applied to the root element if `color="textPrimary"`. */
    colorTextPrimary: {
        color: theme.palette.text.primary,
    },
    /* Styles applied to the root element if `color="textSecondary"`. */
    colorTextSecondary: {
        color: theme.palette.text.secondary,
    },
    /* Styles applied to the root element if `color="error"`. */
    colorError: {
        color: theme.palette.error.main,
    },
    /* Styles applied to the root element if `display="inline"`. */
    displayInline: {
        display: 'inline',
    },
    /* Styles applied to the root element if `display="block"`. */
    displayBlock: {
        display: 'block',
    },
}); };
var variantMapping = {
    heading: 'h1',
    title: 'h2',
    body1: 'p',
    body2: 'p',
    caption: 'p',
    minimum: 'p',
    inherit: 'p',
};
var useStyles = makeStyles(styles, { name: 'SnTypography' });
export var Typography = function (props) {
    var _a;
    var _b = props.align, align = _b === void 0 ? 'inherit' : _b, bold = props.bold, className = props.className, _c = props.color, color = _c === void 0 ? 'initial' : _c, component = props.component, _d = props.display, display = _d === void 0 ? 'initial' : _d, _e = props.noWrap, noWrap = _e === void 0 ? false : _e, paragraph = props.paragraph, _f = props.variant, variant = _f === void 0 ? 'body2' : _f, style = props.style, others = __rest(props, ["align", "bold", "className", "color", "component", "display", "noWrap", "paragraph", "variant", "style"]);
    var classes = useStyles(props);
    var _g = useColor({ color: color }), colorStyle = _g.colorStyle, isCssColor = _g.isCssColor;
    // @ts-ignore
    var Component = component || (paragraph ? 'p' : variantMapping[variant]) || 'span';
    return (React.createElement(Component, __assign({ className: classNames(classes.root, classes[variant], (_a = {},
            _a[classes["align" + capitalize(align)]] = align !== 'inherit',
            _a[classes.bold] = bold,
            _a[classes["color" + capitalize(color)]] = !isCssColor && color !== 'initial',
            _a[classes["display" + capitalize(display)]] = display !== 'initial',
            _a[classes.noWrap] = noWrap,
            _a[classes.paragraph] = paragraph,
            _a), className), style: __assign(__assign({}, colorStyle), style) }, others)));
};
